document.addEventListener('DOMContentLoaded', function () {
    const button = document.querySelector('.scroll-to-top')

    if (button) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 200) {
                button.classList.add('show')
            } else {
                button.classList.remove('show')
            }
        })

        button.addEventListener('click', function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        })
    }
})
